import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly admin session cookie automatically for /api/admin/*
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;
